<h1 class="visually-hidden">{{ 'reporting.reporting' | transloco }}</h1>
<div class="padding">
    <mat-card>
        <mat-card-content>
            <div class="table-container">
                <mat-tab-group animationDuration="0ms" [selectedIndex]="_selectedIndex">
                    <mat-tab [label]="'common.labels.liveReports' | transloco">
                        <app-report-templates-list></app-report-templates-list>
                    </mat-tab>
                    <mat-tab [label]="'common.labels.savedReports' | transloco">
                        <app-requested-reports-list></app-requested-reports-list>
                    </mat-tab>
                    <!-- <mat-tab label="Schedule Reports">
                        Coming Soon!
                    </mat-tab> -->
                </mat-tab-group>
            </div>
        </mat-card-content>
    </mat-card>
</div>